import * as React from 'react';
import styled from 'styled-components';
import {
	cardBorder,
	boxShadow,
	greyColour,
	slateGrey,
	superLightGreyColour,
	tabletPortraitMinWidth,
	whiteColour,
	greyBackground
} from '../../../../cssConstants';
import CheckGreenSvg from '../../../../../images/checkGreen.svg';

const LessonCard = ({
	id,
	imageSrc,
	imageSize,
	title,
	description,
	duration = null,
	onCardClick = null,
	isCompleted = false
}: Props) => {
	return (
		<Card key={id} onClick={() => onCardClick?.(id)}>
			<ImageContainer>
				{isCompleted && <LessonCheck src={CheckGreenSvg} />}
				<Image src={imageSrc} alt={title} width={imageSize.width} height={imageSize.height} />
			</ImageContainer>
			<DetailsContainer>
				<Title>{`${id}. ${title}`}</Title>
				<Description>{description}</Description>
				{duration && <Duration>{duration}</Duration>}
			</DetailsContainer>
		</Card>
	);
};

export default LessonCard;

interface Props {
	id: number;
	imageSrc: string;
	imageSize: { width: string; height: string };
	title: string;
	description: string;
	duration?: string;
	onCardClick?: (index: number) => void;
	isCompleted?: boolean;
}

const Card = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	border: ${cardBorder};
	border-radius: 14px;
	box-shadow: ${boxShadow};
	margin-top: 16px;
	padding: 10px;
	background-color: ${whiteColour};
`;

const LessonCheck = styled.img`
	position: absolute;
	top: 8px;
	left: 8px;
	width: 24px;
	height: 24px;
	display: flex;
`;

const ImageContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 92px;
	height: 92px;
	background-color: ${whiteColour};
	border-radius: 16px;
`;

const Image = styled.img<{ width: string; height: string }>`
	width: ${(props) => props.width};
	height: ${(props) => props.height};
	object-fit: cover;
	border-radius: 14px;
	background: ${greyBackground};
	padding: 8px;
`;

const DetailsContainer = styled.div`
	flex: 1;
	display: flex;
	padding-left: 8px;
	flex-direction: column;
	justify-content: center;
	font-size: 12px;
	font-weight: 500;
	line-height: 16px;
	letter-spacing: 0.5px;
	gap: 10px;
`;

const Title = styled.p`
	color: ${slateGrey};
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 15px;
	letter-spacing: 0.1px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 16px;
		line-height: 24px;
	}
`;

const Description = styled.p`
	color: ${superLightGreyColour};
	font-size: 11px;
	font-weight: 500;
	line-height: 16px;
	letter-spacing: 0.5px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 14px;
		line-height: 20px;
	}
`;

const Duration = styled.p`
	color: ${greyColour};
	font-size: 11px;
	font-weight: 500;
	line-height: 11px;
	letter-spacing: 0.5px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 12px;
		line-height: 16px;
	}
`;
